import devConfig from './config.dev';
import prodConfig from './config.prod';

const isDevelopment = process.env.NODE_ENV === 'development';

const getConfig = () => {
    return isDevelopment ? devConfig : prodConfig;
};

export default getConfig();